export const uk = {
    countries: 'Cтраны',
    'desktop-view': 'Десктоп',
    districts: 'Округа',
    ltv: 'LTV',
    'mobile-view': 'Мобильные',
    'new-tab-view': 'Новая вкладка в браузере',
    regions: 'Регионы'
};
